import React from "react";
import { Row, Col, Container, Card, CardHeader, CardBody } from "reactstrap";
import MainHeading from "../../MainHeading";
import { useTranslation } from "react-i18next";
import "./BannerStyle.scss";
const locat = require("../../../Assets/Images/stack.png");
const bell = require("../../../Assets/Images/bel.png");
const message = require("../../../Assets/Images/message.png");
const people = require("../../../Assets/Images/people.png");
const recieveTip = require("../../../Assets/Images/recieveTip.png");
const giveTip = require("../../../Assets/Images/giveTip.png");
const Features = () => {
  const { t } = useTranslation();
  const features = [
    {
      // bg: "#499662",
      icons: `${giveTip}`,
      // heading: `${t("GIVETIP")}`,
      heading: `TIP GIVERS`,
      // paragraf: `${t("Ourplatform")}`,
      paragraf: `The EasyTipping App places the power of digital gratuity at users' fingertips, enabling them to reward exceptional service promptly by scanning a QR code or inputting a unique user ID. No downloading, No hassle.
      `,
    },
    {
      // bg: "#ffa26b",
      icons: `${people}`,
      // heading: `${t("RECEIVETIP")}`,
      heading: `TIP RECEIVERS`,
      // paragraf: `${t("Receivingtips")}`,
      paragraf: `How many tips have you lost in the last month? Receiving cashless tips means an increase in earnings, making it possible to earn more money for your services instantly, with no more murky pool tipping issues or disappearing tips.`,
    },
    {
      // bg: "#499662",
      icons: `${bell}`,
      // heading: `${t("INSTANTFEEDBACK")}`,
      heading: `BUSINESS OWNERS/OPERATORS`,
      // paragraf: `${t("Theinstantfeedback")}`,
      paragraf: `Our comprehensive tip management system is designed for small businesses, hotels, casinos, and enterprises. From transparent, automated pool tipping to record keeping for your business, we've got you covered. `,
    },
    {
      // bg: "#ffa26b",
      icons: `${recieveTip}`,
      // heading: `${t("MULTIPLEACCOUNTTYPES")}`,
      heading: `SWIFT & SECURE TRANSACTIONS`,
      // paragraf: `${t("Easytippingdoesnt")}`,
      paragraf: `Integrated with established and secure, industry-tested payment gateway platforms
      our user-friendly interface ensures that every transaction is smooth, reliable, and worry-free. `,
    },
    {
      // bg: "#499662",
      icons: `${locat}`,
      // heading: `${t("SWIFT&SECURETRANSACTIONS")}`,
      heading: `UNIQUE QR CODE AND ID GENERATION `,
      // paragraf: `${t("Ourrobustsecurity")}`,
      paragraf: `Each user or team receiving tips is provided with a unique QR code and identification (ID) within the app. This means you can receive tips anytime through the app, not just when you are face-to-face with customers.`,
    },
    {
      // bg: "#ffa26b",
      icons: `${message}`,
      // heading: `${t("UNIQUEQRCODEANDIDGENERATION")}`,
      heading: `INSTANT FEEDBACK`,
      // paragraf: `${t("Eachuserisprovided")}`,
      paragraf: `The server ratings offer a valuable tool to improve staff performance, boost morale, and foster a culture of growth. Employees can enhance their brand and use their star rating for career growth.`,
    },
  ];

  return (
    <section id="canvaFeatures" className="BannerImgFour">
      <Container fluid className="">
        <Row className="">
          <Col md={12} className="text-center">
            <h3 className="nomrateFont display-6 py-2 mt-2">
              {/* {t("AboutUs")} */}
              App Features
            </h3>
          </Col>
        </Row>
        <Row className="justify-content-center h-100">
          <Col md={10}>
            <Row className="h-100">
              {features.map((data) => (
                <Col lg={4} md={6} className="mb-3">
                  <Card
                    className="rounded-4 p-3 m-0 text-center h-100"
                    style={{ backgroundColor: `#FFFFFF` }}
                  >
                    <CardHeader className="bg-transparent border-0 m-0 p-0">
                      <h4 className="nomrateFont mb-0">{data.heading}</h4>
                    </CardHeader>
                    <CardBody>
                      <p className="nomrateFont text-center mb-0">
                        {data.paragraf}
                      </p>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Features;
